// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ManageEachStaffWork_mainWrapper__+w3ad","summaryWrapper":"ManageEachStaffWork_summaryWrapper__ACQBu"};